var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn cm-button",class:[
    _vm.customClass,
    ( _obj = {}, _obj[("btn-" + _vm.variant)] = _vm.variant && !_vm.isOutline, _obj[("btn-outline-" + _vm.variant)] = _vm.variant && _vm.isOutline, _obj['is-line'] =  _vm.variant && _vm.isOutline, _obj['is-disabled'] =  _vm.disabled, _obj['is-block'] =  _vm.isBlock, _obj[("cm-button--" + _vm.size)] = _vm.size, _obj['is-default'] =  _vm.isDefault, _obj ) ],attrs:{"type":_vm.type,"disabled":_vm.disabled},on:{"click":_vm.handler}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }